export default {
    //俄语
    DiagnosticReport:'Диагностический отчет',
    troubleCode:'Код неисправности',
    time:'время',
    noTItle:'Управление производителем',
    TestReport:'Отчет о тестировании',
    VehicleInformation:'Информация об автомобиле',
    DataStream:'Поток данных',
    IMReadiness:'Готовность I/M',
    Communication:'Протокол связи',
    notFaultCode:'Нет кода неисправности',
    nodataflow:'Нет аномального потока данных',
    PositioningPrompt:'Включите функцию локации, чтобы получить местные цены.',
    FaultCode:'Код неисправности',
    AIDiagnosis:'Искусственный интеллект диагностика',
    AIWait:'Отчет по ИИ или ожидание автоматической диагностики',
    FailedFaultCode:'Невозможно получить информацию о коде неисправности',
    AIError:'Ошибка анализа ИИ',
    more:'больше',
    StoredCodes:'Подтвердить код неисправности',
    PendingCodes:'ожидание кода неисправности',
    PermanentCodes:'постоянный код неисправности',
    ManufacturerControl:'Определено производителем автомобиля',
    continue:'продолжать',
    // 引导定位
    notlimits:'Невозможно получить разрешение на определение местоположения',
    setupSteps:'Шаги настройки:',
    openset:'Откройте приложение "Настройки"',
    findSet:'Найдите приложение, которое вы используете',
    clickset:'Нажмите "Положение"',
    selectLimits:'Выберите "в течение использования" или "всегда"',
    blackRefresh:'Вернуться в приложение и обновить страницу',
    openAppSet:'Нажмите "Управление приложениями" или "Приложения"',
    findUseBrowser:'Найдите используемый вами браузер',
    clickAuthority:'Нажмите "Управление правами"',
    findejurisd:'Найдите разрешение "Положение"',
    selectjurisd:'Выберите "Разрешить" или "Разрешить во время использования"',
    phoneJurisd:'Проверьте разрешение на определение местоположения в мобильном приложении:',
    openJurisd:'Включите разрешение "Геолокация"',
    report:'отчет',
    AI:'AI',
    Freeze:'Замороженный кадр',
    VoltageInfo:'Информация о напряжении',
    Voltage:'Напряжение',
    Agent:'Agent',
    think:'Глубокое размышление'
}